import * as React from 'react'
import { apiConsumer, IApiConsumer, IWithAuthStatus, withAuthStatus } from '../../data/ApiProvider'
import { getCustomerDetail, setCustomerStatus } from '../../data/admin/customer.actions'
import { ICustomer } from '../../data/admin/customer.interface'
import { IApiConsumerEntity } from '../../data/actions.interface'
import ARow from '../../components/atoms/ARow'
import ACol from '../../components/atoms/ACol'
import MDescriptiveList from '../../components/molecules/MDescriptiveList'
import MStatisticsList from '../../components/molecules/MStatisticsList'
import CustomerPosts from '../../containers/post/CustomerPosts'
import { formatDate } from '../../utils/format'
import { AButton } from '../../components/atoms'
import APageHeader from '../../components/atoms/APageHeader'
import ReportView from './ReportView'

interface ICustomerDetail extends IApiConsumer, IWithAuthStatus {
    customer: IApiConsumerEntity<ICustomer>
    id: string
    back?: string
    buttons?: Array<React.ReactNode>
}

class CustomerDetail extends React.Component<ICustomerDetail> {
    state = {
        selectedFile: null,
        disabled: false,
        message: '',
    }
    setCustomerStatus = (status: 'active' | 'disabled') => () => {
        this.props.dispatch(setCustomerStatus(this.props.id, status)).catch(console.warn)
    }

    
    render() {
        const { customer, back, auth, buttons = [], id } = this.props
        if (customer.status !== 'success') {
            return 'loading'
        }

        return (
            <React.Fragment>
                <APageHeader
                    back={back}
                    buttons={[
                    auth.isAdmin
                    && (customer.response.status === 'active'
                        ? <AButton outline color="warning" onClick={this.setCustomerStatus('disabled')}>
                            Disable customer
                        </AButton>
                        : <AButton outline color="success" onClick={this.setCustomerStatus('active')}>
                            Enable customer
                        </AButton>),
                    ...buttons,
                ]}
                >
                    {customer.response.status === 'disabled' && 'DISABLED: '} {customer.response.name}
                </APageHeader>
                <ARow>
                    <ACol md={4}>
                        <MStatisticsList
                            title="Statistics"
                            items={[
                                {
                                    name: 'Active users',
                                    icon: 'user2',
                                    to: 'customer',
                                    value: customer.response.userCount,
                                }
                                
                            ]}
                            button={
                                auth.isAdmin
                                    ? {
                                          to: `/admin/customers/${id}/reporting/${customer.response.name}`,
                                          text: 'View report',
                                      }
                                    : {
                                          to: 'reporting',
                                          text: 'View report',
                                      }
                            }
                        />
                    </ACol>
                    <ACol md={4}>
                        <CustomerPosts />
                    </ACol>
                    <ACol md={4}>
                        <MDescriptiveList
                            title={customer.response.name}
                            items={[
                                {
                                    name: 'License',
                                    value: customer.response.status,
                                },
                                {
                                    name: 'Active since',
                                    value: formatDate(customer.response.createdAt),
                                },
                                {
                                    name: 'Admin users',
                                    value: customer.response.adminCount,
                                },
                            ]}
                        />
                    </ACol>
                </ARow>
                {auth.isAdmin && (
                        <ReportView customerId={this.props.id}/>
                )}
                
            </React.Fragment>
        )
    }
}

export default withAuthStatus(
    apiConsumer({
        customer: props => getCustomerDetail(props.id),
    })(CustomerDetail),
)
